import React, { Fragment, useEffect } from 'react'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import { Badge, Skeleton, List } from 'antd'
import {
  FlexWrapper,
  NotifyText,
  ButtonFlex,
  LightText,
  NotifyTexBold,
  NotifyDiv,
  InfoWrap,
  BottomFLex,
} from 'modules/Page/Components/Partials/NotificationDrawer/AllNotificationDetails/style'
import InfiniteScroll from 'react-infinite-scroll-component'
import moment from 'moment'
import EllipseDot from 'components/icons/EllipseDot'
import { useNavigate } from 'react-router-dom'

const NotificationDetails = ({
  notificationData,
  notification,
  setNotification,
  notificationAsRead,
  loading,
  hasMoreData,
  setHasMoreData,
  listData,
  pageNo,
  setPageNo,
}) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (listData?.length) {
      let payload = {
        notificationId: notificationData?.list[0]?._id,
      }
      if (!notificationData?.list[0]?.is_read) {
        notificationAsRead(payload)
      }
    }
  }, [listData])

  const fetchMoreData = () => {
    if (notificationData?.totalPages == pageNo) {
      setHasMoreData(false)
      return
    }
    if (notification) {
      setPageNo(prev => prev + 1)
    }
  }
  const pageNavigate = navLink => {
    setNotification(false)
    navigate(navLink)
  }
  return (
    <NotifyDiv>
      <InfiniteScroll
        dataLength={listData?.length}
        next={fetchMoreData}
        hasMore={hasMoreData}
        loader={
          hasMoreData ? (
            <Skeleton avatar paragraph={{ rows: 2 }} active />
          ) : null
        }
        height={'80vh'}
      >
        <List
          bordered={false}
          dataSource={listData}
          loading={loading}
          renderItem={(item, index) => (
            <Fragment key={index}>
              <List.Item>
                <FlexWrapper key={index} row>
                  <Badge dot={!item?.is_read} offset={[-10, 5]}>
                    <Avatar
                      title={item?.is_read ? '' : 'New'}
                      background="#F2F3F5"
                      src={item?.icon}
                      size={46}
                      IconName={item?.issuer?.charAt(0)?.toUpperCase()}
                    />
                  </Badge>
                  <InfoWrap column>
                    <NotifyText>
                      {!!item?.issuer && (
                        <NotifyTexBold>'{item?.issuer}'</NotifyTexBold>
                      )}
                      {!!item?.body && `  ${item?.body}`}
                    </NotifyText>
                    {!!item?.actions?.length && (
                      <ButtonFlex>
                        {item?.actions?.map((data,index) => (
                          <Button.Primary
                            text={data?.name}
                            key={index+"data"}
                            height={'32px'}
                            onClick={() => pageNavigate(data?.route)}
                          />
                        ))}
                      </ButtonFlex>
                    )}
                    <BottomFLex alignCenter>
                      <LightText>
                        {moment(item?.created_at).fromNow(true)} ago
                      </LightText>
                      <EllipseDot />
                      <LightText>{item?.tag}</LightText>
                    </BottomFLex>
                  </InfoWrap>
                </FlexWrapper>
              </List.Item>
            </Fragment>
          )}
        />
      </InfiniteScroll>
    </NotifyDiv>
  )
}

export default NotificationDetails
